'use client';

import { AnalyticsProvider } from '@unifyapps/carbon/analytics';
import InterfaceHelper from '@unifyapps/carbon/no-code/stores/InterfaceStore/helper/InterfaceHelper';
import type { InterfaceComponentPage } from '@unifyapps/carbon/no-code/types/interfaceComponent';
import type { InterfaceEntity } from '@unifyapps/defs/types/interface';
import { InterfacePageEntityComponentType } from '@unifyapps/defs/types/page';
import _trimStart from 'lodash/trimStart';
import type { PropsWithChildren } from 'react';
import { useCallback } from 'react';

interface MatrixAnalyticsProviderProps {
  isEnabled: boolean;
  interfaceRecord?: InterfaceEntity | undefined;
}

export function MatrixAnalyticsProvider({
  children,
  isEnabled,
  interfaceRecord,
}: PropsWithChildren<MatrixAnalyticsProviderProps>) {
  const getTrackingData = useCallback(() => {
    const slug = _trimStart(window.location.pathname, '/');
    const interfaceComponent: InterfaceComponentPage = {
      slug,
      type: InterfacePageEntityComponentType.PAGE,
    };

    const componentId =
      InterfaceHelper.getInterfaceComponentIdFromSlug(interfaceRecord, interfaceComponent) ?? slug;

    return { componentId };
  }, [interfaceRecord]);

  return (
    <AnalyticsProvider getTrackingData={getTrackingData} isEnabled={isEnabled}>
      {children}
    </AnalyticsProvider>
  );
}
